/**
 * Format job number to display single digit job numbers with leading zero
 * Handles the specific format: [2 Month Letters][Job Number][2 Year Digits]
 * Examples:
 * - MY125 → MY0125 (May, Job #1, Year 25)
 * - MY225 → MY0225 (May, Job #2, Year 25)  
 * - MY1025 → MY1025 (May, Job #10, Year 25 - no change needed)
 * - MY0125 → MY0125 (already formatted - no change)
 * 
 * @param {string|number} jobNumber - The original job number
 * @returns {string} Formatted job number with leading zero for single digit job numbers
 */
export const formatJobNumber = (jobNumber) => {
  if (!jobNumber) return '';
  
  const jobStr = String(jobNumber).trim();
  
  // Handle pure single digits (1, 2, 3, etc.)
  if (/^\d$/.test(jobStr)) {
    return `0${jobStr}`;
  }
  
  // Handle the specific format: [2 Letters][Job Number][25]
  // Match pattern: 2 letters + digits + 25 at the end
  const jobPatternMatch = jobStr.match(/^([A-Za-z]{2})(\d+)(25)$/);
  
  if (jobPatternMatch) {
    const [, monthCode, jobNum, year] = jobPatternMatch;
    
    // Check if job number is single digit and doesn't already have leading zero
    if (jobNum.length === 1) {
      return `${monthCode}0${jobNum}${year}`;
    }
    
    // If job number already has leading zero or is multi-digit, return as-is
    return jobStr;
  }
  
  // For any other format, return unchanged
  return jobStr;
};